import { render, staticRenderFns } from "./oss-image.vue?vue&type=template&id=2df263f8&"
import script from "./oss-image.vue?vue&type=script&lang=js&"
export * from "./oss-image.vue?vue&type=script&lang=js&"
import style0 from "./oss-image.vue?vue&type=style&index=0&id=2df263f8&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports